export default "__VITE_ASSET__VmOnLdVr__"